<script>
  import ButtonSmall from '../ButtonSmall.svelte';

  export let value;
</script>

<div class='game-append'>
  <div class='game-append-field'>
    <a href='./#/fields/{value.field.code}' class='game-append-field-label'> {value.field.city} ({value.field.shortcut.toUpperCase()}) </a>
    <a href='./#/fields/{value.field.code}' class='game-append-field-shortcut'> {value.field.shortcut.toUpperCase()} </a>
  </div>

  <div class='game-append-score'>
    {#if ![undefined, null].includes(value.score.visitor) && ![undefined, null].includes(value.score.home)}
      <div class='game-append-score-visitor'>
        {value.score.visitor}
      </div>

      <div class='game-append-score-colon'> : </div>

      <div class='game-append-score-home'>
        {value.score.home}
      </div>
    {:else}
      <div class='game-append-score-play-by-play'>
        <ButtonSmall icon='sports_baseball' link={value.playByPlay} color='green'/>
      </div>

      <div class='game-append-score-space'/>

      <div class='game-append-score-stream'>
        <ButtonSmall icon='live_tv' link={value.stream} color='red'/>
      </div>
    {/if}
  </div>
</div>

<style>
  .game-append {
    display: flex;
    gap: 10px;

    width: 200px;
  }

  .game-append-field {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 20px;

    color: var(--grey-5);
  }

  .game-append-field-label {
    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    color: inherit;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .game-append-field-shortcut {
    display: none;

    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    color: inherit;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .game-append-field-label:hover, .game-append-field-shortcut:hover {
    text-decoration-color: var(--grey-5);
  }

  .game-append-score {
    display: flex;
  }

  .game-append-score-visitor, .game-append-score-home {
    display: flex;
    justify-content: center;
    align-items: center;

    width: calc(20px / 3 * 4);
    height: 20px;

    font-family: var(--font-secondary);
    font-weight: bold;
  }

  .game-append-score-colon {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 10px;
    height: 20px;

    font-family: var(--font-secondary);
    font-weight: bold;
  }

  .game-append-score-play-by-play, .game-append-score-stream {
    width: calc(20px / 3 * 4);
  }

  .game-append-score-space {
    width: 10px;
  }

  :global(body.dark) .game-append-field {
    color: var(--grey-6);
  }

  :global(body.dark) .game-append-field-label:hover, :global(body.dark) .game-append-field-shortcut:hover {
    text-decoration-color: var(--grey-6);
  }

  @media only screen and (max-width: 1300px) and (min-width: 1050px) {
    :global(.schedule-narrow) .game-append {
      width: 125px;
    }

    :global(.schedule-narrow) .game-append-field-label {
      display: none;
    }

    :global(.schedule-narrow) .game-append-field-shortcut {
      display: block;
    }
  }

  @media only screen and (max-width: 850px) {
    .game-append {
      width: 125px;
    }

    .game-append-field-label {
      display: none;
    }

    .game-append-field-shortcut {
      display: block;
    }
  }
</style>
